import InteractionsTableSentimentColumnMenuItem from "./interactions-table-sentiment-column-menu-item";
import SentimentIcons from "components-for/sentiment/sentiment-icons";
import { Cell, Column, Heading } from "@edgetier/client-components";
import { FunctionComponent, memo } from "react";
import { IInteraction, Sentiment } from "@edgetier/watchtower-types";
import { IProps } from "./interactions-table-sentiment-column.types";
import { updateUrl, useSentimentParameters } from "./interactions-table-sentiment-column.utilities";
import { useHistory, useLocation } from "react-router-dom";
import "./interactions-table-sentiment-column.scss";

/**
 * A sentiment column that can be filtered to only show a single metric.
 * @returns Table column.
 */
const InteractionsTableSentimentColumn: FunctionComponent<IProps> = () => {
    const { push } = useHistory();
    const { search } = useLocation();
    const currentFilters = useSentimentParameters();

    /**
     * Update the URL when the user filters by an interaction.
     * @param filter Filter name.
     */
    const onFilter = (filter: keyof typeof currentFilters) => {
        push({ search: updateUrl(currentFilters, filter, search) });
    };

    return (
        <Column>
            <Heading
                isFiltered={Object.values(currentFilters).some((value) => value)}
                menu={
                    <div className="interactions-table-sentiment-column__menu">
                        <InteractionsTableSentimentColumnMenuItem
                            isActiveFilter={currentFilters.hasFrustration}
                            onClick={onFilter}
                            sentiment={Sentiment.Frustration}
                        >
                            Frustration
                        </InteractionsTableSentimentColumnMenuItem>

                        <InteractionsTableSentimentColumnMenuItem
                            isActiveFilter={currentFilters.hasGratitude}
                            onClick={onFilter}
                            sentiment={Sentiment.Gratitude}
                        >
                            Gratitude
                        </InteractionsTableSentimentColumnMenuItem>

                        <InteractionsTableSentimentColumnMenuItem
                            isActiveFilter={currentFilters.hasPraise}
                            onClick={onFilter}
                            sentiment={Sentiment.Praise}
                        >
                            Praise
                        </InteractionsTableSentimentColumnMenuItem>
                    </div>
                }
            >
                Emotion
            </Heading>
            <Cell<IInteraction>>
                {({ hasFrustration, hasGratitude, hasPraise }) => (
                    <SentimentIcons hasFrustration={hasFrustration} hasGratitude={hasGratitude} hasPraise={hasPraise} />
                )}
            </Cell>
        </Column>
    );
};

export default memo(InteractionsTableSentimentColumn);
